(() => {
  const initialize = (overlapHeroEvent) => {
    const element = overlapHeroEvent.element;
    const button = element.querySelector('.overlap-hero-event__toggle-events');
    const details = element.querySelector('.overlap-hero-event__details');
    const icon = element.querySelector('.overlap-hero-event__toggle-icon');
    const text = element.querySelector('.overlap-hero-event__toggle-text');

    const toggle = (event) => {
      event.preventDefault();
      details.classList.toggle('overlap-hero-event__details--hide');

      return icon.textContent.includes('+') ? ((icon.textContent = '-'), (text.textContent = 'Hide All Events')) : ((icon.textContent = '+'), (text.textContent = 'Show All Events'));
    };

    button.addEventListener('click', toggle);
  };

  const overlapHeroEvent = stp.setup('overlap-hero-event');

  overlapHeroEvent.map(initialize);
})();
